import { createAction, createActions } from "redux-actions";
import { GetSagaProps } from "src/modules/modules.type";

export enum MyDocumentsActionsType {
  GET_MY_DOCUMENTS_INFO = "GET_MY_DOCUMENTS_INFO",
  GET_MY_DOCUMENTS_INFO_SUCCESS = "GET_MY_DOCUMENTS_INFO_SUCCESS",
  GET_MY_DOCUMENTS_INFO_FAILURE = "GET_MY_DOCUMENTS_INFO_FAILURE",
  GET_MY_DOCUMENTS_INFO_IDLE = "GET_MY_DOCUMENTS_INFO_IDLE",
}

const getMyDocumentsInfo = createAction<GetSagaProps>(MyDocumentsActionsType.GET_MY_DOCUMENTS_INFO);

const { getMyDocumentsInfoSuccess, getMyDocumentsInfoFailure, getMyDocumentsInfoIdle } = createActions(
  MyDocumentsActionsType.GET_MY_DOCUMENTS_INFO,
  MyDocumentsActionsType.GET_MY_DOCUMENTS_INFO_SUCCESS,
  MyDocumentsActionsType.GET_MY_DOCUMENTS_INFO_FAILURE,
  MyDocumentsActionsType.GET_MY_DOCUMENTS_INFO_IDLE
);

export { getMyDocumentsInfo, getMyDocumentsInfoSuccess, getMyDocumentsInfoFailure, getMyDocumentsInfoIdle };
